import * as storage from '@/utils/storage'

// initial state
const state = {
  spaces: { name: 'spaces-list'},
  projects: { name: 'projects-list'}
}
// getters
const getters = {
  spaces: state => state.spaces,
  projects: state => state.projects,
}

// mutations
const mutations = {
  setSpaces(state, route) {
    state.spaces = route
  },
  setProjects(state, route) {
    state.projects = route
  }
}

export default {
  state,
  getters,
  mutations
}
